import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { LandingPage } from "../app/_website";
import { FindEventsPage } from "../app/_website/find-events";
import { PricingPage } from "../app/_website/pricing";
import { ErrorPage } from "../app/error";
import { LegalPage } from "../app/legal";
import { Layout } from "../components/layout/layout";

export const websiteRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <Layout>
            <LandingPage />
          </Layout>
        ),
      },
      {
        path: "find-events",
        element: (
          <Layout>
            <FindEventsPage />
          </Layout>
        ),
      },
      {
        path: "pricing",
        element: (
          <Layout>
            <div className="absolute inset-0 flex items-end">
              <img
                alt="gradient"
                src="/assets/images/gradientBg.png"
                className="sticky bottom-0 hidden w-full object-cover md:block md:object-contain"
              />
              <img
                alt="gradient"
                src="/assets/images/gradientBgMobile.png"
                className="sticky bottom-0 block w-full object-cover md:hidden md:object-contain"
              />
            </div>
            <PricingPage />
          </Layout>
        ),
      },
      {
        path: "legal/:doc",
        element: (
          <Layout footerClassName="mt-10">
            <LegalPage className="max-width" />
          </Layout>
        ),
      },
      {
        path: "404",
        element: (
          <Layout>
            <PageNotFound />
          </Layout>
        ),
      },
    ],
  },

  {
    path: "*",
    element: (
      <Layout>
        <PageNotFound />
      </Layout>
    ),
  },
];
